import React from 'react';
import { CONTACT_INFO, SOCIAL_LINKS, getWhatsAppURL } from '../../config/contactConfig';
import {
  FOOTER_NEWSLETTER,
  FOOTER_COMPANY,
  FOOTER_SECTIONS,
  FOOTER_SOCIAL,
  FOOTER_APP_DOWNLOAD,
  FOOTER_BOTTOM_LINKS,
  FOOTER_COPYRIGHT_SUFFIX
} from '../../config/footerContent';

const SocialIcon = ({ name }) => {
  const iconClass = 'w-5 h-5';
  const normalized = String(name || '').toLowerCase();

  if (normalized === 'facebook') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.5-3.88 3.77-3.88 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.9h-2.34v6.99A10 10 0 0 0 22 12z" />
      </svg>
    );
  }

  if (normalized === 'x' || normalized === 'twitter') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M18.244 2H21l-6.59 7.53L22 22h-6.828l-5.346-6.992L3.7 22H1l7.048-8.055L2 2h7l4.83 6.34L18.244 2zm-2.392 18h1.885L8.004 3.895H6.02L15.852 20z" />
      </svg>
    );
  }

  if (normalized === 'instagram') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm9.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
      </svg>
    );
  }

  if (normalized === 'youtube') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.4.6A3 3 0 0 0 .5 6.2 31.9 31.9 0 0 0 0 12a31.9 31.9 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.6 9.4.6 9.4.6s7.5 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.9 31.9 0 0 0 24 12a31.9 31.9 0 0 0-.5-5.8zM9.6 15.5v-7l6.2 3.5-6.2 3.5z" />
      </svg>
    );
  }

  if (normalized === 'linkedin') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M4.98 3.5A2.49 2.49 0 1 0 5 8.48 2.49 2.49 0 0 0 4.98 3.5zM3 9h4v12H3zM9 9h3.8v1.7h.1c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.5c0-1.3-.02-3-1.82-3-1.83 0-2.11 1.43-2.11 2.9V21H9z" />
      </svg>
    );
  }

  if (normalized === 'whatsapp') {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className={iconClass} aria-hidden="true">
        <path d="M12.04 2A9.93 9.93 0 0 0 3.5 17.1L2 22l5.04-1.46A10 10 0 1 0 12.04 2zm5.72 14.34c-.24.68-1.4 1.27-1.94 1.35-.5.08-1.14.12-1.84-.1-.43-.14-.98-.32-1.68-.63-2.96-1.28-4.9-4.45-5.05-4.65-.14-.2-1.2-1.6-1.2-3.05 0-1.45.76-2.16 1.03-2.46.27-.3.58-.37.78-.37h.56c.18 0 .41-.07.64.48.24.58.8 2 .88 2.15.07.15.12.33.02.53-.1.2-.15.33-.3.5-.14.17-.3.38-.43.5-.14.12-.28.25-.12.5.16.25.7 1.14 1.51 1.84 1.03.9 1.9 1.18 2.15 1.3.25.13.4.1.55-.06.15-.15.65-.76.83-1.02.18-.25.35-.2.58-.12.24.08 1.5.7 1.76.84.25.13.42.2.48.32.06.12.06.7-.18 1.38z" />
      </svg>
    );
  }

  return <span className="text-xs font-semibold">{String(name || '?').slice(0, 1)}</span>;
};

const getSocialButtonClasses = (name) => {
  const normalized = String(name || '').toLowerCase();

  if (normalized === 'facebook') return 'bg-[#1877F2] hover:bg-[#1664cc] text-white';
  if (normalized === 'x' || normalized === 'twitter') return 'bg-black hover:bg-gray-900 text-white';
  if (normalized === 'instagram') return 'bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] hover:brightness-110 text-white';
  if (normalized === 'youtube') return 'bg-[#FF0000] hover:bg-[#d10000] text-white';
  if (normalized === 'linkedin') return 'bg-[#0A66C2] hover:bg-[#0955a1] text-white';
  if (normalized === 'whatsapp') return 'bg-[#25D366] hover:bg-[#1ebe5a] text-white';

  return 'bg-gray-800 hover:bg-orange-600 text-white';
};

const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();

  const handleWhatsAppContact = (message = CONTACT_INFO.WHATSAPP_MESSAGES.INQUIRY) => {
    window.open(getWhatsAppURL(message), '_blank');
  };

  const handleFooterAction = (link) => {
    if (link.type === 'route') {
      if (onNavigate) {
        onNavigate(link.target);
      }
      return;
    }

    if (link.type === 'whatsapp') {
      handleWhatsAppContact(CONTACT_INFO.WHATSAPP_MESSAGES.INQUIRY);
      return;
    }

    console.log(`${link.name} clicked`);
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Newsletter Subscription Section */}
      <div className="bg-gradient-to-r from-orange-600 to-amber-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
          <div className="text-center">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              {FOOTER_NEWSLETTER.title}
            </h3>
            <p className="text-orange-100 mb-6 max-w-2xl mx-auto">
              {FOOTER_NEWSLETTER.description}
            </p>
            <div className="flex flex-col sm:flex-row max-w-md mx-auto gap-3">
              <input
                type="email"
                placeholder={FOOTER_NEWSLETTER.placeholder}
                className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-white focus:outline-none text-gray-900"
              />
              <button className="px-6 py-3 bg-white text-orange-600 font-semibold rounded-lg hover:bg-gray-100 transition-colors">
                {FOOTER_NEWSLETTER.buttonLabel}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="/themaithil_logo.png"
                alt="TheMaithil logo"
                className="w-8 h-8 mr-2 object-contain"
              />
              <span className="text-xl font-bold">{CONTACT_INFO.COMPANY_NAME}</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {FOOTER_COMPANY.description}
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 text-sm">
              <div className="flex items-center">
                <span className="mr-3">📞</span>
                <a href={`tel:+91${CONTACT_INFO.PHONE}`} className="text-gray-400 hover:text-orange-500 transition-colors">
                  +91 {CONTACT_INFO.PHONE}
                </a>
              </div>
              <div className="flex items-center">
                <span className="mr-3">✉️</span>
                <a href={`mailto:${CONTACT_INFO.EMAIL}`} className="text-gray-400 hover:text-orange-500 transition-colors">
                  {CONTACT_INFO.EMAIL}
                </a>
              </div>
              <div className="flex items-center">
                <span className="mr-3">💬</span>
                <button 
                  onClick={() => handleWhatsAppContact(CONTACT_INFO.WHATSAPP_MESSAGES.INQUIRY)}
                  className="text-gray-400 hover:text-green-400 transition-colors"
                >
                  {FOOTER_COMPANY.whatsappLabel}
                </button>
              </div>
              <div className="flex items-center">
                <span className="mr-3">📍</span>
                <span className="text-gray-400">{CONTACT_INFO.ADDRESS}</span>
              </div>
            </div>
          </div>

          {/* Footer Sections */}
          {FOOTER_SECTIONS.map((section, index) => (
            <div key={index} className="lg:col-span-1">
              <h4 className="text-lg font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <button
                      onClick={() => handleFooterAction(link)}
                      className="text-gray-400 hover:text-white transition-colors text-sm"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social Links and App Downloads */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-6 lg:space-y-0">
            {/* Social Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-center lg:text-left">{FOOTER_SOCIAL.heading}</h4>
              <div className="flex justify-center lg:justify-start space-x-4">
                {SOCIAL_LINKS.map((social, index) => (
                  social.name === 'WhatsApp' ? (
                    <button
                      key={index}
                      onClick={() => handleWhatsAppContact(CONTACT_INFO.WHATSAPP_MESSAGES.INQUIRY)}
                      className={`group relative w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${getSocialButtonClasses(social.name)}`}
                      title={social.name}
                      aria-label={social.name}
                    >
                      <SocialIcon name={social.name} />
                      <span className="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-950 px-2 py-1 text-[11px] text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        {social.name}
                      </span>
                    </button>
                  ) : (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`group relative w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${getSocialButtonClasses(social.name)}`}
                      title={social.name}
                      aria-label={social.name}
                    >
                      <SocialIcon name={social.name} />
                      <span className="pointer-events-none absolute -top-9 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-md bg-gray-950 px-2 py-1 text-[11px] text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                        {social.name}
                      </span>
                    </a>
                  )
                ))}
              </div>
            </div>

            {/* App Download */}
            <div>
              <h4 className="text-lg font-semibold mb-4 text-center lg:text-right">{FOOTER_APP_DOWNLOAD.heading}</h4>
              <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-3">
                {FOOTER_APP_DOWNLOAD.stores.map((store) => (
                  <button key={store.id} className="bg-gray-800 hover:bg-gray-700 px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors">
                    <span className="text-2xl">{store.icon}</span>
                    <div className="text-left">
                      <div className="text-xs text-gray-400">{store.eyebrow}</div>
                      <div className="text-sm font-semibold">{store.label}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {CONTACT_INFO.COMPANY_NAME}. {FOOTER_COPYRIGHT_SUFFIX}
            </div>
            <div className="flex space-x-6 text-sm">
              {FOOTER_BOTTOM_LINKS.map((link) => (
                <button key={link.target} onClick={() => handleFooterAction(link)} className="text-gray-400 hover:text-white transition-colors">
                  {link.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
